import variables from './variables'

export default {
  meta: { themeName: 'cpu' },

  globalNav: {
    background: variables.colors.cpu4,
    iconHoverBackground: variables.colors.opacity_20,
  },
  colors: {
    buttons: {
      primaryBackground: variables.colors.cpu4,
      primaryBackgroundHover: variables.colors.cpu1,
      primaryBackgroundDisabled: variables.colors.buttonDisabledKit,
      secondaryText: variables.colors.darkGray,
      secondaryOutline: variables.colors.gray600,
      tabActive: variables.colors.cpu2,
      tabDefault: variables.colors.cpu5,
    },
    heading: {
      level: {
        1: variables.colors.cpu2,
        2: variables.colors.cpu2,
        3: variables.colors.cpu2,
      },
    },
    links: {
      primary: variables.colors.cpu4,
      primaryHover: variables.colors.cpu2,
    },
    themeAccent: variables.colors.cpu5,
    themeHighlight: variables.colors.cpu2,
    themePrimary: variables.colors.cpu4,
    themeSecondary: variables.colors.cpu1,
  },
  buttons: {
    borderRadius: '21.5px',
  },
  banners: {
    headerTextColor: variables.colors.black,
    headerTextFont: 'Sharpslab-bold',
    headerTextSize: '36px',
    bannerTextColor: variables.colors.darkGray,
    landingBackgroundColor: variables.colors.transparent,
    alignment: 'flex-start',
    textAlignment: 'left',
  },
  callouts: {
    headerTextColor: variables.colors.black,
    headerTextFont: 'Sharpslab-bold',
    headerTextSize: '28px',
    bodyTextColor: variables.colors.darkGray,
    backgroundColor: variables.colors.lighterGray,
    iconBorderRadius: '0.688rem 0.688rem 0.688rem 0.688rem',
    boxShadow: `0px 3px 0px ${variables.colors.gray500}`,
  },
  resources: {
    backgroundColorTop: variables.colors.transparent,
    backgroundColorBottom: variables.colors.transparent,
  },
  anchorNavigation: {
    borderBottomStyle: 'dotted',
    borderBottomColor: '#BBBBBB',
    borderBottomWidth: 'thick',
    topPadding: '0.688rem',
    bottomPadding: '0.5rem',
    boxShadow: `none`,
  },
}
